import { ComponentProps } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import AccessLink from "@components/AccessLink/AccessLink";
import "./FoodSectionMoreLink.scss";

type Props = Omit<ComponentProps<typeof AccessLink>, "className" | "style">;

/** Right-aligned "More ... >" footer link shared by the sections of the refreshed Food Profile. */
const FoodSectionMoreLink: FCX<Props> = ({ className, ...linkProps }) => (
    <div className={cn("FoodSectionMoreLink", className)}>
        <AccessLink {...linkProps} className="FoodSectionMoreLink__link" />
    </div>
);

export default FoodSectionMoreLink;
